import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import AdvanceTableSearchBox from "components/common/advance-table/AdvanceTableSearchBox";
import ShimmerUI from "components/ShimmerUI/PatientShimmer";
import useAdvanceTable from "hooks/useAdvanceTable";
import moment from "moment";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import { Alert } from "react-bootstrap";

const LoginHistoryTab = ({ data }) => {

    const columns = [
        {
            accessorKey: 'created_at',
            header: 'Date / Time',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original } }) => (
                <span className="text-nowrap">
                    {moment(original.created_at).format('MMM DD, YYYY HH:mm')}
                </span>
            ),
        },
        {
            accessorKey: 'accessed_url',
            header: 'Accessed URL',
            meta: { headerProps: { className: 'text-900' } },
            cell: ({ row: { original } }) => (
                <code className="fs--1">{original.accessed_url ?? '—'}</code>
            ),
        }
    ];
    const table = useAdvanceTable({
        data,
        columns,
        sortable: true,
        pagination: true,
    });

    return (
        <>
            { data.length > 0 ? <AdvanceTableProvider {...table}>
                <div className="mb-2">
                    <AdvanceTableSearchBox placeholder="Search..." />
                </div>
                <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle text-900"
                    rowClassName="align-middle white-space-nowrap"
                    tableProps={{
                        size: 'sm',
                        striped: true,
                        className: 'fs-10 mb-0 overflow-hidden',
                    }}
                />
                <div className="mt-2">
                    <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                </div>
            </AdvanceTableProvider> : <Alert variant="info" className="text-center">No Activity log found.</Alert>}

        </>
    );
};

export default LoginHistoryTab;